import React from 'react';
import ReferralStats from '../components/ReferralStats/ReferralStats';

const ReferralStatsPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <ReferralStats 
        onError={(error) => {
          // You can add toast notification here if needed
          console.error(error);
        }}
      />
    </div>
  );
};

export default ReferralStatsPage;
